import React from 'react';
import { ApolloProvider } from '@apollo/react-common';
import { ThemeProvider } from '@material-ui/styles';
import { BrowserRouter, StaticRouter } from 'react-router-dom';
import { useHistory } from 'react-router';

import theme from './theme';
import { CommonLayout } from './containers/CommonLayout';
import createApolloClient from '../src/graphql';
import { ModalsController } from './context/ModalsContext';
import { ScriptsController } from './context/ScriptsContext';
import { RXDController } from './context/RXDContext';
import { DiscoverController } from './context/DiscoverContext';
import { TestController } from './context/TestContext';
import { SUSTAINABILITY_REFERENT } from './utils/const';

const ROUTERS = {
  server: StaticRouter,
  client: BrowserRouter,
};

const getApolloClient = (type, client, redirect) => {
  if (type === 'server') {
    return client;
  }
  return createApolloClient(redirect);
};

function ApolloLoader({ type = 'client', client, host }) {
  const history = useHistory();

  const apolloClient = getApolloClient(type, client, () => history.replace('/'));

  apolloClient.writeData({
    data: {
      hasNews: !host?.includes(SUSTAINABILITY_REFERENT),
    },
  });

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme}>
        <CommonLayout />
      </ThemeProvider>
    </ApolloProvider>
  );
}

function App({ type, client = undefined, context, location, host = '' }) {
  const Router = ROUTERS[type];

  return (
    <>
      <ModalsController>
        <ScriptsController>
          <RXDController>
            <DiscoverController>
              <TestController>
                <Router context={context} location={location}>
                  <ApolloLoader type={type} client={client} host={host} />
                </Router>
              </TestController>
            </DiscoverController>
          </RXDController>
        </ScriptsController>
      </ModalsController>
    </>
  );
}

export default App;
